import { Model } from 'modules/core/lib/mobx-rest'

export interface IShare {
  id?: string
  granter_id: string
  grantee_type: GranteeType
  grantee_id: string
  resource_type: ResourceType
  resource_id: string
  metadata: { [key: string]: unknown } | null
}

export const ResourceTypes = {
  Report: 'Reports::Report',
} as const

export type ResourceType = (typeof ResourceTypes)[keyof typeof ResourceTypes]

const GranteeTypes = {
  Access: 'Access',
} as const

export type GranteeType = (typeof GranteeTypes)[keyof typeof GranteeTypes]

/**
 * Generic share model with untyped metadata.
 * In most cases we shouldn't be using this one, instead, we should create domain-specific models
 * that extend IShare, typing its metadata and providing methods that make sense for each domain.
 *
 * @see ReportShare
 */
class Share extends Model<IShare> {
  get primaryKey() {
    return 'id'
  }

  static urlRoot() {
    return '/permissions/shares'
  }
}
